import { UseQueryResult, useQuery } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { CompanyBranchData, CompanyBranchResponse } from "@/features/company/types/company.type";

type UseCompanyBranch = (id: string, enabled?: boolean, retry?: boolean | number) => UseQueryResult<CompanyBranchData, unknown>

export const useCompanyBranch: UseCompanyBranch = (id, enabled = true, retry = true) => {
  const privateAxios = usePrivateAxios();

  return useQuery<CompanyBranchResponse, unknown, CompanyBranchData>({
    enabled,
    queryKey: ['companyBranch', id],
    queryFn: () => privateAxios.get(`/company_branches/${id}`),
    select: (data) => data?.data?.data,
    retry: retry
  });
};
